let TMP_EASY_EDU_SERVER_BASE_URL = "";
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // dev code
  console.log("DEV ENV");
  TMP_EASY_EDU_SERVER_BASE_URL = "http://localhost:8080" + "/api";
} else {
  // production code
  console.log("PROD ENV");
  TMP_EASY_EDU_SERVER_BASE_URL = window._env_.EASY_EDU_SERVER_REST_URL + "/api";
}

export const EASY_EDU_SERVER_BASE_URL = TMP_EASY_EDU_SERVER_BASE_URL;
